import { HeroServiceFloatOverlay, type HeroFloatImage } from "@/components/hero-service-float-overlay";

/** Marquee float tiles + readability wash for service page heroes. */
export function ServiceHeroFloatLayer({ images }: { images?: HeroFloatImage[] }) {
  return (
    <>
      <HeroServiceFloatOverlay images={images} />
      <div
        className="absolute inset-0 z-[2] pointer-events-none bg-gradient-to-r from-primary/35 via-primary/5 to-primary/25 md:from-primary/45 md:via-primary/15 md:to-transparent"
        aria-hidden
      />
    </>
  );
}
